import { render, staticRenderFns } from "./personalPortal.vue?vue&type=template&id=2eec0820&scoped=true&"
import script from "./personalPortal.vue?vue&type=script&lang=js&"
export * from "./personalPortal.vue?vue&type=script&lang=js&"
import style0 from "./personalPortal.vue?vue&type=style&index=0&id=2eec0820&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eec0820",
  null
  
)

export default component.exports